import React from "react";
import { Table, Form } from "react-bootstrap";
import "./index.scss";
import RowActions from "../RowActions";

const DataTable = ({ columns, data, keyField, rowActions }) => {
  return (
    <Table hover responsive>
      <thead>
        <tr>
          <th>
            <Form.Check type="checkbox" />
          </th>
          {columns.map((col) => (
            <th key={col.accessor}>{col.header}</th>
          ))}
          {rowActions && <th>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <tr key={row[keyField]}>
            <td>
              <Form.Check type="checkbox" />
            </td>
            {columns.map((col) => (
              <td key={col.accessor}>
                {col.Cell
                  ? col.Cell(row[col.accessor], row)
                  : row[col.accessor]}
              </td>
            ))}
            {rowActions && (
              <td>
                <RowActions actions={rowActions(row)} />
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default DataTable;
